import Completable from './Completable';

/**
 * Represents a new task. This mirrors the database version of a task
 * completely.
 */
export default class Task extends Completable {}
